import i18n from 'i18next';

import translationRU from './locales/ru.json';
import translationEN from './locales/en.json';
import translationUK from './locales/uk.json';
import { INIT_UI_LANGUAGE } from 'constants/languages';

// the translations
const resources = {
  ru: {
    translation: translationRU,
  },
  en: {
    translation: translationEN,
  },
  uk: {
    translation: translationUK,
  },
};

i18n.init({
  resources,
  lng: INIT_UI_LANGUAGE,
  fallbackLng: 'en',
  debug: false,

  // keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
